module.exports = __webpack_public_path__ + "./Carina_00ed2261fa7219da2f27e9264f3d3fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Carina.jpg
// module id = 546
// module chunks = 0